import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { GaAuthState, UserSession } from '../models/index';
import { GaSessionState, getSessionError, getSessionIsAuthenticated, getSessionState, getSessionUser } from '../store/index';
import * as sessionStore from '../store/session.store';

@Injectable()
export class GaSessionService {

    constructor(
        private store: Store<GaSessionState>
    ) { }

    get isAuthenticated(): boolean {
        let res;
        this.isAuthenticated$.pipe(take(1)).subscribe(f => res = f);
        return res;
    }

    get state$(): Observable<GaAuthState> { return this.store.select(getSessionState); }

    get sessionUser$(): Observable<UserSession> { return this.store.select(getSessionUser); }

    get error$(): Observable<any> { return this.store.select(getSessionError); }

    get isAuthenticated$(): Observable<boolean> { return this.store.select(getSessionIsAuthenticated); }

    signin(login: string, password: string): void {
        this.store.dispatch(sessionStore.signinAction({ login, password }));
    }

    signinAbort(): void {
        this.store.dispatch(sessionStore.signinAbortAction());
    }

    signout(): void {
        this.store.dispatch(sessionStore.signoutAction());
    }

    restore(): void {
        this.store.dispatch(sessionStore.restoreAction());
    }
}
